<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card class="mb-base" :title="$t('Edicion')" v-if="canEdit" >
          <div class="text-right mb-3" >
            <a
              target="_blank"
              :href="$router.resolve({ name: 'publicCarta', params: { id: carte.id, slug: carte.slug_restaurant, lang: carte.current_language }}).href"
              class="mr-2"
            >
              <vs-button
                type="border"
              >
                {{ $t('carta.VerCarta') }}
              </vs-button>
            </a>
            <generate-qr
              :id="carte.id"
              type="cartedish"
              classSpan="vs-button vs-button-primary vs-button-border"
            />
          </div>
          <edit-carte :carte="carte" ></edit-carte>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
    import EditCarte from '../components/Cartes/EditCarte';
    import GenerateQr from '../components/GenerateQr';
    import {mapActions, mapGetters} from 'vuex';
    export default {
        components: {
            EditCarte,
            GenerateQr
        },
        data () {
            return {
            }
        },
        created () {
            this.getCarte({ id: this.$route.params.id, language: this.language});
        },
        computed: {
            ...mapGetters({
                carte: 'getCarte',
                language: 'getCurrentLanguage'
            }),
            canEdit () {
                if (Object.keys(this.carte).length > 0) {
                    return true;
                }
                return false;
            },
        },
        methods: {
            ...mapActions({
                getCarte: 'getCarte',
            })
        }
    }

</script>

<style>

</style>
